
/**
 * 測速 以promise.any 抓最快返回的resolve
 * @param [] urls
 * @param {*} setting
 * @returns string
 */
export async function speedTest(urls = [], setting = {}) {
  let speedTestResult;
  try {
    const requestUrls = urls.map(url=>httpClient(url, setting))
    speedTestResult = await Promise.any(requestUrls);
  } catch (error) {
    console.log(error);
  }
  return speedTestResult;

}
/**
 * xhr
 * @param {*} url
 * @param {method, xhrTimeout, failCallback, successCallback} setting
 * @returns Promise<String>
 */
export function httpClient(url, setting ) {
  const defaultSetting = { method:'GET', xhrTimeout: 3000 ,failCallBack:()=>{}, successCallback:()=>{} }
  const { method, xhrTimeout, failCallBack, successCallback } = { ...setting, ...defaultSetting };
  const xhr = new XMLHttpRequest();
  return new Promise((resolve, reject)=>{
    xhr.open(method, url)
    xhr.onerror = function() {
      failCallBack()
      return reject(`xhr error (${url})`)
    }
    xhr.ontimeout = function() {
      failCallBack()
      return reject(`xhr timeout (${url})`)
    }
    xhr.onload = function(e) {
      if(e.target.status === 200) {
        successCallback()
        return resolve(url)
      } else {
        failCallBack()
        return reject(`xhr stateCode:${e.target.status} (${url})`)
      }
    }
    xhr.timeout = xhrTimeout
    xhr.send()

  })

}
